<template>
  <div class="row">
    <div class="col-sm-12 cart-items">
      <div class="cart-item-qty">
        <select id="qty-dropdown" class="cart-qty-dropdown" @change="updateQt($event)">
          <option
            v-for="num in qtyNumbers"
            :key="num.ID"
            :id="'option-' + num"
            :selected="num == cartItem.quantity"
          >{{ num }}</option>
        </select>
      </div>
      <div class="cart-item-details gift-cart">
        <div class="item-details-name">{{ cartItem.name | camelCase }}</div>
        <ul v-if="cartItem.message">
          <li v-if="cartItem.message.From">{{$t("message.fromName")}}: {{ cartItem.message.From }}</li>
          <li v-if="cartItem.message.To">{{$t("message.toName")}}: {{ cartItem.message.To }}</li>
          <li v-if="cartItem.message.Message">{{ cartItem.message.Message }}</li>
        </ul>
        <a
          href="#"
          class="text-primary"
          @click.prevent="removeCartItem(cartItem)"
        >{{ $t('message.remove') }}</a>
      </div>
      <div class="cart-item-cost gift-cart">{{ price | formatMoney(currencySign) }}</div>
    </div>
  </div>
</template>

<script>
import shared from "../../../sharedscripts/giftcard/details";

export default {
  props: {
    cartItem: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      qtyNumbers: []
    };
  },
  computed: {
    ...shared.computed,
    price() {
      let sum = this.cartItem.price;

      return sum * this.cartItem.quantity;
    }
  },
  created() {
    let that = this;
    var numbers = new Array();
    for (var i = 1; i <= 20; i++) {
      numbers.push(i.toString());
    }
    that.qtyNumbers = numbers;
  },
  methods: {
    ...shared.methods
  }
};
</script>
